/** Add a player only after the visitor activates its poster. */
export function initVideos(scope = document) {
  scope.querySelectorAll('[data-video-url]').forEach((container) => {
    if (container.dataset.videoReady) return;
    container.dataset.videoReady = 'true';
    const trigger = container.querySelector('[data-video-play]');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const url = parseVideoUrl(container.dataset.videoUrl);
      if (!url) return;

      let player;
      if (url.type === 'file') {
        player = document.createElement('video');
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
        const source = document.createElement('source');
        source.src = url.url;
        source.type = url.mime;
        player.append(source);
      } else {
        player = document.createElement('iframe');
        player.src = url.url;
        player.title = container.dataset.videoTitle || 'Video player';
        player.allow =
          'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
        player.allowFullscreen = true;
      }
      trigger.hidden = true;
      container.append(player);
    });
  });
}

function parseVideoUrl(value) {
  let url;
  try {
    url = new URL(value);
  } catch (error) {
    return null;
  }
  if (url.protocol !== 'https:') return null;

  const host = url.hostname.toLowerCase();
  if (
    host === 'youtu.be' ||
    host === 'www.youtube.com' ||
    host === 'youtube.com' ||
    host === 'www.youtube-nocookie.com' ||
    host === 'youtube-nocookie.com'
  ) {
    const id =
      host === 'youtu.be'
        ? url.pathname.slice(1)
        : url.searchParams.get('v') || url.pathname.split('/').pop();
    if (!/^[A-Za-z0-9_-]{11}$/.test(id)) return null;
    return {
      type: 'iframe',
      url: `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`,
    };
  }
  if (
    host === 'vimeo.com' ||
    host === 'www.vimeo.com' ||
    host === 'player.vimeo.com'
  ) {
    const id = url.pathname.split('/').filter(Boolean).pop();
    if (!/^\d+$/.test(id)) return null;
    return {
      type: 'iframe',
      url: `https://player.vimeo.com/video/${id}?autoplay=1`,
    };
  }
  if (/\.mp4$/i.test(url.pathname)) {
    return { type: 'file', url: url.href, mime: 'video/mp4' };
  }
  if (/\.webm$/i.test(url.pathname)) {
    return { type: 'file', url: url.href, mime: 'video/webm' };
  }
  return null;
}
